export default {
  path: '/app',
  component: () => import('@/layout/AppShell.vue'),
  children: [
    {
      path: '/app',
      name: 'home',
      component: () => import('@/views/Dashboard.vue'),
      meta: {
        capability: 'home',
        breadcrumb: { label: 'Dashboard', icon: 'pi pi-home' }
      }
    },
    {
      path: '/app/my-logs',
      name: 'my-logs',
      component: () => import('@/views/MyLogsRoute.vue'),
      meta: {
        breadcrumb: { label: 'My Logs', icon: 'pi pi-database' }
      }
    },
    {
      path: '/app/my-logs/new',
      name: 'my-logs-new',
      component: () => import('@/views/v2/LogFormPage.vue'),
      meta: {
        requiresV2: true,
        breadcrumb: { label: 'New Log', icon: 'pi pi-plus' }
      }
    },
    {
      path: '/app/my-logs/:id/edit',
      name: 'my-logs-edit',
      component: () => import('@/views/v2/LogFormPage.vue'),
      meta: {
        requiresV2: true,
        breadcrumb: { label: 'Edit Log', icon: 'pi pi-pencil' }
      }
    },
    {
      path: '/app/my-portfolio',
      name: 'my-portfolio',
      component: () => import('@/views/MyPortfolio.vue'),
      meta: {
        capability: 'portfolio',
        breadcrumb: { label: 'My Portfolio', icon: 'pi pi-graduation-cap' }
      }
    },
    {
      path: '/app/my-requests',
      name: 'My Requests',
      component: () => import('@/views/MyRequests.vue'),
      meta: {
        capability: 'requests',
        breadcrumb: { label: 'My Requests', icon: 'pi pi-folder' }
      }
    },
    {
      path: '/app/analytics',
      name: 'analytics',
      component: () => import('@/components/Analytics.vue'),
      meta: {
        capability: 'analytics',
        breadcrumb: { label: 'Analytics', icon: 'pi pi-chart-pie' }
      }
    },
    {
      path: '/app/admin',
      name: 'Admin',
      component: () => import('@/views/admin/Admin.vue'),
      meta: {
        roles: ['admin'],
        breadcrumb: { label: 'Admin Dashboard', icon: 'pi pi-cog' }
      }
    },
    {
      path: '/app/admin/templates',
      name: 'AdminTemplates',
      component: () => import('@/views/admin/AdminTemplates.vue'),
      meta: {
        roles: ['admin'],
        breadcrumb: { label: 'Templates', icon: 'pi pi-file-edit' }
      }
    },
    {
      path: '/app/admin/users',
      name: 'AdminUsers',
      component: () => import('@/views/admin/AdminUsers.vue'),
      meta: {
        roles: ['admin'],
        breadcrumb: { label: 'Users', icon: 'pi pi-users' }
      }
    },
    {
      path: '/app/admin/schools',
      name: 'AdminSchools',
      component: () => import('@/views/admin/AdminSchools.vue'),
      meta: {
        roles: ['admin'],
        breadcrumb: { label: 'Schools', icon: 'pi pi-home' }
      }
    },
    {
      path: '/app/admin/organisations',
      name: 'AdminOrganisations',
      component: () => import('@/views/admin/AdminOrganisations.vue'),
      meta: {
        roles: ['admin'],
        breadcrumb: { label: 'Organisations', icon: 'pi pi-building' }
      }
    },
    {
      path: '/app/admin/support',
      name: 'AdminSupport',
      component: () => import('@/views/admin/AdminSupport.vue'),
      meta: {
        roles: ['admin'],
        breadcrumb: { label: 'Support', icon: 'pi pi-headphones' }
      }
    },
    {
      path: '/app/admin/app-logs',
      name: 'AdminLogs',
      component: () => import('@/views/admin/AdminLogs.vue'),
      meta: {
        roles: ['admin'],
        breadcrumb: { label: 'Logs', icon: 'pi pi-list' }
      }
    },
    {
      path: '/app/school-management',
      name: 'School Management',
      component: () => import('@/views/SchoolManagement.vue'),
      redirect: '/app/school-management/dashboard',
      meta: {
        roles: ['school-manager'],
        breadcrumb: { label: 'School Management', icon: 'pi pi-wrench' }
      },
      children: [
        {
          path: 'dashboard',
          name: 'SchoolDashboard',
          component: () => import('@/views/school-management/SchoolDashboard.vue'),
          meta: {
            roles: ['school-manager'],
            breadcrumb: { label: 'Dashboard', icon: 'pi pi-th-large' }
          }
        },
        {
          path: 'overview',
          name: 'SchoolOverview',
          component: () => import('@/views/school-management/SchoolOverview.vue'),
          meta: {
            roles: ['school-manager'],
            breadcrumb: { label: 'Overview', icon: 'pi pi-chart-line' }
          }
        },
        {
          path: 'teachers',
          name: 'SchoolTeachers',
          component: () => import('@/views/school-management/SchoolTeachers.vue'),
          meta: {
            roles: ['school-manager'],
            breadcrumb: { label: 'Teachers', icon: 'pi pi-users' }
          }
        },
        {
          path: 'teams',
          name: 'SchoolTeams',
          component: () => import('@/views/school-management/SchoolTeams.vue'),
          meta: {
            roles: ['school-manager'],
            breadcrumb: { label: 'Teams', icon: 'pi pi-sitemap' }
          }
        },
        {
          path: 'analytics',
          name: 'SchoolAnalytics',
          component: () => import('@/views/school-management/SchoolAnalytics.vue'),
          meta: {
            roles: ['school-manager'],
            breadcrumb: { label: 'Analytics', icon: 'pi pi-chart-bar' }
          }
        },
        {
          path: 'logs',
          name: 'SchoolLogs',
          component: () => import('@/views/school-management/SchoolLogs.vue'),
          meta: {
            roles: ['school-manager'],
            breadcrumb: { label: 'Logs', icon: 'pi pi-database' }
          }
        },
        {
          path: 'templates',
          name: 'SchoolTemplates',
          component: () => import('@/views/school-management/SchoolTemplates.vue'),
          meta: {
            roles: ['school-manager'],
            breadcrumb: { label: 'Templates', icon: 'pi pi-file-edit' }
          }
        },
        {
          path: 'requests',
          name: 'SchoolRequests',
          component: () => import('@/views/school-management/SchoolRequests.vue'),
          meta: {
            roles: ['school-manager'],
            breadcrumb: { label: 'Requests', icon: 'pi pi-folder' }
          }
        }
      ]
    },
    {
      path: '/app/my-account',
      name: 'My Account',
      component: () => import('@/views/MyAccount.vue'),
      redirect: '/app/my-account/dashboard',
      meta: {
        breadcrumb: { label: 'My Account', icon: 'pi pi-user' }
      },
      children: [
        {
          path: 'dashboard',
          name: 'MyAccountDashboard',
          component: () => import('@/views/my-account/MyAccountDashboard.vue'),
          meta: {
            breadcrumb: { label: 'Dashboard', icon: 'pi pi-th-large' }
          }
        },
        {
          path: 'profile',
          name: 'MyAccountProfile',
          component: () => import('@/views/my-account/MyAccountProfile.vue'),
          meta: {
            breadcrumb: { label: 'Profile', icon: 'pi pi-user' }
          }
        },
        {
          path: 'career',
          name: 'MyAccountCareer',
          component: () => import('@/views/my-account/MyAccountCareer.vue'),
          meta: {
            breadcrumb: { label: 'Career Details', icon: 'pi pi-briefcase' }
          }
        },
        {
          path: 'security',
          name: 'MyAccountSecurity',
          component: () => import('@/views/my-account/MyAccountSecurity.vue'),
          meta: {
            breadcrumb: { label: 'Security', icon: 'pi pi-lock' }
          }
        },
        {
          path: 'billing',
          name: 'MyAccountBilling',
          component: () => import('@/views/my-account/MyAccountBilling.vue'),
          meta: {
            breadcrumb: { label: 'Billing Information', icon: 'pi pi-credit-card' }
          }
        },
        {
          path: 'export',
          name: 'MyAccountExport',
          component: () => import('@/views/my-account/MyAccountExport.vue'),
          meta: {
            breadcrumb: { label: 'Export Data', icon: 'pi pi-download' }
          }
        }
      ]
    },
    {
      path: '/app/support',
      name: 'Support',
      component: () => import('@/views/SupportDashboard.vue'),
      meta: {
        breadcrumb: { label: 'Support', icon: 'pi pi-question-circle' }
      }
    },
    {
      path: '/app/support/requests',
      name: 'SupportRequests',
      component: () => import('@/views/SupportRequests.vue'),
      meta: {
        breadcrumb: { label: 'Support Requests', icon: 'pi pi-envelope' }
      }
    },
    {
      path: '/app/support/faq',
      name: 'SupportFAQ',
      component: () => import('@/views/SupportFAQ.vue'),
      meta: {
        breadcrumb: { label: 'FAQ', icon: 'pi pi-info-circle' }
      }
    }
  ]
};
